export default function RoomsLoading() {
  return (
    <div className="col-span-4  grid grid-flow-row grid-cols-4 gap-3 ">
      <div className="flex flex-col w-full col-span-4 py-2 px-2 lg:col-span-2 overflow-hidden  cursor-pointer">
        <div
          className="grow flex flex-row "
        >
          <div className="h-[92px] w-[92px] bg-slate-200 animate-pulse rounded-[10px] overflow-hidden">

          </div>
          <div className="flex grow flex-col ps-3 ">
            <div className="flex flex-col">
              <div className="pb-1 mb-2 bg-slate-200 animate-pulse h-5 w-20 text-sm font-semibold capitalize text-gray-800 6 line-clamp-2 rounded">
              </div>
              <div className="flex flex-col gap-2">
                <p className="bg-slate-200 mb-3 animate-pulse rounded h-4 w-20">
                </p>
                <div className="flex flex-row items-center justify-between gap-2">
                  <div className="text-gray-500 text-xs flex flex-row gap-2 items-center">
                    <p className="bg-slate-200 animate-pulse rounded h-4 w-20">
                    </p>
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <p className="h-5 w-12 rounded animate-pulse bg-slate-200">

                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                <div
                  className="bg-slate-200 animate-pulse w-16 h-4 rounded"
                >
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
      <div className="flex flex-col w-full col-span-4 py-2 px-2 lg:col-span-2 overflow-hidden  pb-3 cursor-pointer">
        <div
          className="grow flex flex-row "
        >
          <div className="h-[92px] w-[92px] bg-slate-200 animate-pulse rounded-[10px] overflow-hidden">

          </div>
          <div className="flex grow flex-col ps-3 ">
            <div className="flex flex-col">
              <div className="pb-1 mb-2 bg-slate-200 animate-pulse h-5 w-20 text-sm font-semibold capitalize text-gray-800 6 line-clamp-2 rounded">
              </div>
              <div className="flex flex-col gap-2">
                <p className="bg-slate-200 mb-3 animate-pulse rounded h-4 w-20">
                </p>
                <div className="flex flex-row items-center justify-between gap-2">
                  <div className="text-gray-500 text-xs flex flex-row gap-2 items-center">
                    <p className="bg-slate-200 animate-pulse rounded h-4 w-20">
                    </p>
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <p className="h-5 w-12 rounded animate-pulse bg-slate-200">

                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                <div
                  className="bg-slate-200 animate-pulse w-16 h-4 rounded"
                >
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
      <div className="flex flex-col w-full col-span-4 py-2 px-2 lg:col-span-2 overflow-hidden  pb-3 cursor-pointer">
        <div
          className="grow flex flex-row "
        >
          <div className="h-[92px] w-[92px] bg-slate-200 animate-pulse rounded-[10px] overflow-hidden">

          </div>
          <div className="flex grow flex-col ps-3 ">
            <div className="flex flex-col">
              <div className="pb-1 mb-2 bg-slate-200 animate-pulse h-5 w-20 text-sm font-semibold capitalize text-gray-800 6 line-clamp-2 rounded">
              </div>
              <div className="flex flex-col gap-2">
                <p className="bg-slate-200 mb-3 animate-pulse rounded h-4 w-20">
                </p>
                <div className="flex flex-row items-center justify-between gap-2">
                  <div className="text-gray-500 text-xs flex flex-row gap-2 items-center">
                    <p className="bg-slate-200 animate-pulse rounded h-4 w-20">
                    </p>
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <p className="h-5 w-12 rounded animate-pulse bg-slate-200">

                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                <div
                  className="bg-slate-200 animate-pulse w-16 h-4 rounded"
                >
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
      <div className="flex flex-col w-full col-span-4 py-2 px-2 lg:col-span-2 overflow-hidden  pb-3 cursor-pointer">
        <div
          className="grow flex flex-row "
        >
          <div className="h-[92px] w-[92px] bg-slate-200 animate-pulse rounded-[10px] overflow-hidden">

          </div>
          <div className="flex grow flex-col ps-3 ">
            <div className="flex flex-col">
              <div className="pb-1 mb-2 bg-slate-200 animate-pulse h-5 w-20 text-sm font-semibold capitalize text-gray-800 6 line-clamp-2 rounded">
              </div>
              <div className="flex flex-col gap-2">
                <p className="bg-slate-200 mb-3 animate-pulse rounded h-4 w-20">
                </p>
                <div className="flex flex-row items-center justify-between gap-2">
                  <div className="text-gray-500 text-xs flex flex-row gap-2 items-center">
                    <p className="bg-slate-200 animate-pulse rounded h-4 w-20">
                    </p>
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <p className="h-5 w-12 rounded animate-pulse bg-slate-200">

                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                <div
                  className="bg-slate-200 animate-pulse w-16 h-4 rounded"
                >
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>


    </div>
  );
}
